export default "__VITE_ASSET__wzjG99PN__"